import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AdminGuard } from './routes/guards/admin.guard';
import { ExOrgGuard } from './routes/guards/ex-org.guard';


import { LandownerPostcardComponent } from '@app/landowner/components/landowner-directmail-onboard/landowner-postcard/landowner-postcard.component';
import { CreateListingProxyComponent } from '@app/landowner/components/landowner-directmail-onboard/create-listing-proxy/create-listing-proxy.component';
import { PmtConfirmRetComponent } from '@app/pmt-confirm-ret/pmt-confirm-ret.component';
import { AiSearchComponent } from './new-search/ai-search.component';
import { newSearchMatcher, legacySearchRedirectGuard } from '@app/new-search/legacy-search-redirect.guard';
import { StateCountiesComponent } from '@app/new-search/state-counties/state-counties.component';
import { NewauthfaqComponent } from './newauthfaq/newauthfaq.component';
import { LoginComponent } from './login/login.component';

import { EmailSubscribeComponent } from './email-subscribe/email-subscribe.component';
import { PrivacyPolicyComponent } from './shared2-components/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './shared2-components';
import { SafetyComponent } from './shared2-components/safety/safety.component';


export const routes: Routes = [
    { path: '', loadComponent:() => import('./home/home-container/home-container.component').then(x => x.HomeContainerComponent),
        data: {
            title: 'Outdoor Access',
            description: 'Hunting Leases,  Fishing Leases and Outdoor Recreation leases  by the day, week, or season.',
            preload: true
        }
    },
    { path: 'home', redirectTo: '/',
        data: {
            title: 'Outdoor Access',
            description: 'Your number one resource to lease land for outdoor activites',
        }
    },
    { path: 'contact-us', loadComponent:() => import('./home/contact-us/contact-us.component').then(x => x.ContactUsComponent),
        data: {
            title: 'Contact Outdoor Access',
            description: 'Contact us to learn more about leasing your land for hunting, fishing, or other wildlife activites.',
        }
    },
    { path: 'search', loadComponent: () => import('./search/search.component').then(x => x.SearchComponent), 
        data: {
            title: 'Search Outdoor Access',
            description: 'Search for land for hunting, fishing, paddlesports, or any of your favorite outdoor activites.',
        } },
    { path: 'aboutus', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule),
        data: {
            title: 'About Outdoor Access',
            description: 'Learn more about how our team is helping landowners to lease private land for hunting, fishing, or other wildlife activites.',
        } },
    { path: 'stories', loadChildren: () => import('./stories/stories.module').then(m => m.StoriesModule),
        data: {
            title: 'Stories of Outdoor Access',
            description: 'Here are some real life stories from our Outdoor Access members.',
        } },
    { path: 'listing', loadChildren: () => import('./listing/listing.module').then(m => m.ListingModule), 
        data: { preload: false } },
    { path: 'user', loadChildren: () => import('./user/user.module').then(m => m.UserModule), canActivate: [MsalGuard],
        data: { preload: false } },
    { path: 'landowner', loadChildren: () => import('./landowner/landowner.module').then(m => m.LandownerModule)},
    { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), canActivate: [MsalGuard, AdminGuard] },
    { path: 'eoh/:code', loadComponent:() => import('./home/home-container/home-container.component').then(x => x.HomeContainerComponent), canActivate: [MsalGuard, ExOrgGuard] },
    { path: 'agreement/:id', loadComponent:() => import('./common-components/agreement-view/agreement-view.component').then(x => x.AgreementViewComponent)},
    { path: 'ambassador', loadComponent:() => import('./home/ambassador-home/ambassador-home.component').then(x => x.AmbassadorHomeComponent),canActivate: [MsalGuard, ExOrgGuard], data: { preload: false, exOrgCode: 'OAA' } },
    { path: 'checkout', loadChildren: () => import('./checkout/checkout.routes').then(m => m.checkoutRoutes), canActivate: [MsalGuard] },
    { path: 'purchase-summary', loadComponent:() => import('./post-purchase-summary/post-purchase-summary.component').then(x => x.PostPurchaseSummaryComponent) },
    { path: 'eo', loadChildren: () => import('./external-org/external-org.module').then(m => m.ExternalOrgModule) },
    { path: 'editor', loadChildren: () => import('./html-editor/html-editor.module').then(m => m.HtmlEditorModule) },
    { path: 'resun', loadComponent:() => import('./common-components/resource-unavailable/resource-unavailable.component').then(x => x.ResourceUnavailableComponent)},
    { path: 'landowner-postcard', component: LandownerPostcardComponent},
    { path: 'create-listing-proxy', component: CreateListingProxyComponent},
    { path: 'pmt-confirm-ret', component: PmtConfirmRetComponent},
    { path: 'subscribe', component: EmailSubscribeComponent},
    // /newsearch and everything under it now hands off to Oa.Web's
    // LegacySearchRedirectController (same path), which 301s to the parallel
    // search page on the Next.js site.
    { matcher: newSearchMatcher, canActivate: [legacySearchRedirectGuard], children: [] },
    { path: 'aisearch', component: AiSearchComponent, canActivate: [MsalGuard] },
    { path: 'state-counties/:stateId', component: StateCountiesComponent },
    { path: 'newauthfaq', component: NewauthfaqComponent },
    { path: 'login', component: LoginComponent },
    { path: 'privacypolicy', component: PrivacyPolicyComponent },
    { path: 'terms-of-service', component: TermsOfServiceComponent },
    { path: 'safety', component: SafetyComponent },
    // Landing point for Stripe redirect-based payments (e.g. Klarna) in the My-Offer checkout flow.
    // CheckoutPaymentComponent sets return_url to /checkout-return before calling confirmPayment so
    // Stripe sends the user here after the bank/BNPL redirect.  AppComponent.handleSpecialSituations()
    // explicitly excludes this path so it doesn't intercept the payment_intent query params.
    { path: 'checkout-return', loadComponent: () => import('./checkout/checkout-redirect-return/checkout-redirect-return.component').then(x => x.CheckoutRedirectReturnComponent), canActivate: [MsalGuard] },
    { path: '**', redirectTo: '/' }
];

